import React from 'react';

export default function PersonTypeToggle({ isMoral, onPersonTypeChange, isLawyer = false }) {
  const handleToggle = type => {
    const isMoralPerson = type === 'moral';
    onPersonTypeChange(isMoralPerson);
  };

  return (
    <div className="flex justify-center gap-2">
      <button
        type="button"
        className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors duration-150 ${
          !isMoral
            ? isLawyer
              ? 'bg-white text-lawyer-bg shadow-md border-white'
              : 'bg-gray-700 text-white shadow-md border-gray-700'
            : isLawyer
              ? 'bg-transparent text-gray-200 border-gray-500'
              : 'bg-transparent text-gray-900 border-gray-300'
        }`}
        onClick={() => handleToggle('fisica')}
      >
        Persona Física
      </button>
      <button
        type="button"
        className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors duration-150 ${
          isMoral
            ? isLawyer
              ? 'bg-white text-lawyer-bg shadow-md border-white'
              : 'bg-gray-700 text-white shadow-md border-gray-700'
            : isLawyer
              ? 'bg-transparent text-gray-200 border-gray-500'
              : 'bg-transparent text-gray-900 border-gray-300'
        }`}
        onClick={() => handleToggle('moral')}
      >
        Persona Moral
      </button>
    </div>
  );
}
